import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FormState } from '../_reducers/form.reducers';

const getFormFeatureState = createFeatureSelector<FormState>('form');

export const getFormsLoading = createSelector(
  getFormFeatureState,
  (state: FormState) => state?.formsLoading
);

export const getFormFieldsLoading = createSelector(
  getFormFeatureState,
  (state: FormState) => state?.formfieldsLoading
);

export const getformRulesLoading = createSelector(
  getFormFeatureState,
  (state: FormState) => state?.formRulesStateLoading
);

export const getFormFieldUsersLoading = createSelector(
  getFormFeatureState,
  (state: FormState) => state?.formFieldUsersLoading
);

export const getRelatedDataLoading = createSelector(
  getFormFeatureState,
  (state: FormState) => state?.relatedDataLoading
);

export const getformSavedfieldsLoading = createSelector(
  getFormFeatureState,
  (state: FormState) => state?.formSavedFieldsLoading
);

/**
 * Select for fields
 */
export const getFormFields = createSelector(
  getFormFeatureState,
  (state: FormState) => state?.fields
);

/**
 * Select for forms
 */
export const getForms = createSelector(
  getFormFeatureState,
  (state: FormState) => state?.forms
);

export const getFormsByTables = createSelector(
  getFormFeatureState,
  (state: FormState) => state?.formsByTables
);

/**
 * Select for single form
 */
export const getForm = createSelector(
  getFormFeatureState,
  (state: FormState) => state?.form
);

/**
 * Select operations
 */
export const getFormOperations = createSelector(
  getFormFeatureState,
  (state: FormState) => state?.operations
);

/**
 * Select dependent records
 */
export const getDependentRecords = createSelector(
  getFormFeatureState,
  (state: FormState) => state?.dependentRecords
);

/**
 * Select for form ids
 */
export const getFormIDs = createSelector(
  getFormFeatureState,
  (state: FormState) => state?.formIds
);

/**
 * Select form data
 */
export const getFormData = createSelector(
  getFormFeatureState,
  (state: FormState) => state?.formData
);

/**
 * Select form saved fields
 */
export const getformSavedfields = createSelector(
  getFormFeatureState,
  (state: FormState) => state?.formSavedFields
);

/**
 * Select Form Rules
 */
export const getformRules = createSelector(
  getFormFeatureState,
  (state: FormState) => state?.formRulesState
);

/**
 * Select error
 */
export const getError = createSelector(
  getFormFeatureState,
  (state: FormState) => state?.error
);

/**
 * Select Sync error
 */
export const getSyncError = createSelector(
  getFormFeatureState,
  (state: FormState) => state?.syncError
);

export const getFormFieldUsers = createSelector(
  getFormFeatureState,
  (state: FormState) => state?.formFieldUsers
);

export const getRelatedData = createSelector(
  getFormFeatureState,
  (state: FormState) => state?.relatedData
);

export const getSyncData = createSelector(
  getFormFeatureState,
  (state: FormState) => state?.syncData
);

export const getSigningRequestData = createSelector(
  getFormFeatureState,
  (state: FormState) => state?.signingRequestData
);

export const getSendDocumentConfirmation = createSelector(
  getFormFeatureState,
  (state: FormState) => state?.documentConfirmationData
);

export const getSVGData = createSelector(
  getFormFeatureState,
  (state: FormState) => state?.svgData
);
